<script setup>
import { ref, watch } from 'vue';
import { useQuery } from '@vue/apollo-composable';
import { GET_PRIVACYPOLICIES } from '../hooks/queries';

function renderBody(blocks) {
  return blocks
    .map((block) => {
      if (block.type === 'paragraph') {
        const text = block.children.map((child) => child.text).join('');
        return `<p>${text}</p>`;
      }
      return '';
    })
    .join('');
}


const policy = ref(null);

// Run GraphQL query
const { result, loading, error } = useQuery(GET_PRIVACYPOLICIES);

watch(result, (newResult) => {
  const firstItem = newResult?.privacypolicies?.[0];  
  if (firstItem ) {
    policy.value = firstItem;
  }
});

</script>

<template>
  <div class="container py-5">
    <div class="card shadow-sm">
      <div class="card-body">
        <template v-if="loading">
          <div class="text-center py-4">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
            <p class="mt-3">Loading privacy policy...</p>
          </div>
        </template>

        <template v-else-if="error">
          <div class="alert alert-danger" role="alert">
            Error loading privacy policy. Please try again later.
          </div>
        </template>

        <template v-else-if="policy">
          <h3 class="mb-3">{{ policy.title }}</h3>
          <p><strong>Effective Date:</strong> {{ policy.effectivedate }}</p>

          <hr />

          <div v-for="(privacypolicy, index) in policy.privacypolicy" :key="index" class="mb-4">
            <h5 class="text-primary">{{ privacypolicy.header }}</h5>
            <div v-html="renderBody(privacypolicy.main)" class="text-body"></div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

